import { Grid } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getProductList } from "../../../modules/products/action";
import ItemCard from "../../Common/ItemCard";
import Loader from "../../Loader";
import printer from "./../../../assets/images/printer.png"
import roll from "./../../../assets/images/printerRoll.png"

class FarmUtilities extends Component {
  state = {
    cartList: [],
    expanded: []
  };

  isItemAdded = productId => {
    const { cartList } = this.props;
    return cartList.includes(productId);
  };

  getCount = productId => {
    const { cartList } = this.props;
    return cartList.filter(item => item === productId).length;
  };

  handleExpandClick = productId => {
    const { expanded } = this.state;
    if (expanded.includes(productId)) {
      const currentExpandedItems = [...this.state.expanded];
      const index = currentExpandedItems.indexOf(productId);
      if (index >= 0) currentExpandedItems.splice(index, 1);
      this.setState({
        expanded: currentExpandedItems
      });
    } else {
      const expanded = [...this.state.expanded, productId];
      this.setState({
        expanded
      });
    }
  };

  render() {
    const {
      productList,
      isFetchingComplete,
      handlePurchase,
      handleRemoveItem
    } = this.props;
    console.log('productlist',productList)
    return (
      <Grid
        container
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-evenly"
        }}
      >
        {isFetchingComplete ? (
          productList.map(item => (
            <ItemCard
              key={item.productCode}
              image={item.id==1?printer:roll}
              price={item.fees}
              name={item.name}
              link={item.puchaseLink}
              quantity={this.getCount(item.productCode)}
              productId={item.productCode}
              isItemAdded={this.isItemAdded(item.productCode)}
              handleExpandClick={this.handleExpandClick}
              purchaseItem={handlePurchase}
              removeItem={handleRemoveItem}
              btnLabel="Add to Cart"
              description={item.description}
              expanded={this.state.expanded}
            />
          ))
        ) : (
          <Loader />
        )}
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    productList: state.productsReducer.productList,
    isFetchingComplete: state.productsReducer.isFetchingComplete
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getProductList }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FarmUtilities);



// WEBPACK FOOTER //
// ./src/components/private/FarmUtilities/FarmUtilities.js